import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { ClientId, DateSchema, SecurityId, VirtualAccountId, } from "../../Types";
import ValidationError from "../../ZodError";
import { TradeProposalId } from "../types";
// Define TLH swap schema based on the Vanadium endpoint
const TLHSwapSchema = z.object({
    originalSecurity: SecurityId,
    replacementSecurity: SecurityId,
    virtualAccountId: VirtualAccountId,
    tradeProposalId: TradeProposalId,
    startDate: DateSchema,
    expireDate: DateSchema,
    isActive: z.boolean(),
});
export const TLHSwapsResponseSchema = z.object({
    data: TLHSwapSchema.array(),
});
export const TLHSwapsQuerySchema = z.object({
    clientId: ClientId,
});
export const url = (params) => {
    const qs = new URLSearchParams();
    if (params !== null) {
        qs.append("clientId", params.clientId);
    }
    const qsString = qs.toString() === "" ? "" : `?${qs.toString()}`;
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/tlh-swaps${qsString}`
        : `https://middleware.uat.farther.com/investment/tlh-swaps${qsString}`;
};
export const getTlhSwaps = async (params, config) => {
    const { data } = await axios.get(url(params), {
        headers: {
            version: "20250415",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = TLHSwapsResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = `[${getTlhSwaps.name}] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getTlhSwaps.js.map